import { default as login } from './login';
import { default as createUser } from './create-user';
import { default as modifyUser } from './modifyUser';
import { default as forgotPassword } from './forgot-password';
import { default as updatePassword } from './update-password';
import { default as filterUsers } from './filter-users';
import { default as formHelpInfo } from './help-info';
import { default as compensationSentenceInfo } from './compensation-sentence';
import formReason from './reason';
import formSituation from './situation';
import formProductCode from './product-code';
import formTypology from './typology';
import formMask from './form-mask';
import sendCommunication from './send-communication';
import createProfil from './create-profil';
import modifyProfil from './modify-profil';

export default {
  login,
  createUser,
  modifyUser,
  forgotPassword,
  updatePassword,
  filterUsers,
  formHelpInfo,
  compensationSentenceInfo,
  formReason,
  formProductCode,
  formSituation,
  formTypology,
  formMask,
  sendCommunication,
  createProfil,
  modifyProfil,
};
